import { $Q, $Qll } from "../utils/query-selector";

/**
 * hidde the images
 */

 function hideElements(parent) {
  const aditionalVariants = $Qll(".elements-hidden", parent);

  aditionalVariants.forEach((element) => {
    element.style.display = "none";
  });
}

/**
 * Show the images hidden
 */

 function showElements(parent) {
  const aditionalVariants = $Qll(".elements-hidden", parent);

  aditionalVariants.forEach((element) => {
    element.style.display = "block";
  });
}

/**
 * Read the button extends or hidde the images for the color element
 */

export function onClickDeploy(parent) {
  const deployBtn = $Q(".button-display-js", parent);

  if (deployBtn) {
    deployBtn.addEventListener('click', () => {
      if (deployBtn.dataset.deploy === 'false') {
        showElements(parent);
        deployBtn.dataset.deploy = 'true';
        deployBtn.textContent = deployBtn.dataset.less;
      } else {
        hideElements(parent)
        deployBtn.dataset.deploy = 'false';
        deployBtn.textContent = deployBtn.dataset.more;
      }
    });
  }
}
